/** Static Iran province → city list for e-sign address step (searchable). */

export type IranProvince = {
  name: string;
  cities: string[];
};

export const IRAN_PROVINCES: IranProvince[] = [
  {
    name: "تهران",
    cities: ["تهران", "شهریار", "اسلامشهر", "ری", "قدس", "ملارد", "پاکدشت", "ورامین"],
  },
  {
    name: "البرز",
    cities: ["کرج", "فردیس", "نظرآباد", "ساوجبلاغ", "طالقان", "اشتهارد"],
  },
  {
    name: "اصفهان",
    cities: ["اصفهان", "کاشان", "نجف‌آباد", "خمینی‌شهر", "شاهین‌شهر", "فلاورجان"],
  },
  {
    name: "فارس",
    cities: ["شیراز", "مرودشت", "جهرم", "فسا", "لار", "کازرون"],
  },
  {
    name: "خراسان رضوی",
    cities: ["مشهد", "نیشابور", "سبزوار", "تربت‌حیدریه", "قوچان", "کاشمر"],
  },
  {
    name: "آذربایجان شرقی",
    cities: ["تبریز", "مراغه", "مرند", "میانه", "اهر", "سراب"],
  },
  {
    name: "آذربایجان غربی",
    cities: ["ارومیه", "خوی", "مهاباد", "بوکان", "میاندوآب", "سلماس"],
  },
  {
    name: "مازندران",
    cities: ["ساری", "بابل", "آمل", "قائم‌شهر", "بهشهر", "تنکابن"],
  },
  {
    name: "گیلان",
    cities: ["رشت", "انزلی", "لاهیجان", "آستارا", "رودسر", "تالش"],
  },
  {
    name: "خوزستان",
    cities: ["اهواز", "آبادان", "دزفول", "ماهشهر", "خرمشهر", "اندیمشک"],
  },
  {
    name: "کرمان",
    cities: ["کرمان", "رفسنجان", "جیرفت", "سیرجان", "بم", "زرند"],
  },
  {
    name: "یزد",
    cities: ["یزد", "میبد", "اردکان", "مهریز", "تفت"],
  },
  {
    name: "قم",
    cities: ["قم"],
  },
  {
    name: "قزوین",
    cities: ["قزوین", "تاکستان", "آبیک", "بوئین‌زهرا"],
  },
  {
    name: "همدان",
    cities: ["همدان", "ملایر", "نهاوند", "تویسرکان", "اسدآباد"],
  },
  {
    name: "کرمانشاه",
    cities: ["کرمانشاه", "اسلام‌آباد غرب", "سنقر", "کنگاور", "هرسین"],
  },
  {
    name: "کردستان",
    cities: ["سنندج", "سقز", "مریوان", "بانه", "قروه"],
  },
  {
    name: "لرستان",
    cities: ["خرم‌آباد", "بروجرد", "دورود", "الیگودرز", "کوهدشت"],
  },
  {
    name: "مرکزی",
    cities: ["اراک", "ساوه", "خمین", "محلات", "دلیجان"],
  },
  {
    name: "هرمزگان",
    cities: ["بندرعباس", "میناب", "قشم", "کیش", "بندرلنگه"],
  },
  {
    name: "بوشهر",
    cities: ["بوشهر", "برازجان", "گناوه", "کنگان", "عسلویه"],
  },
  {
    name: "سیستان و بلوچستان",
    cities: ["زاهدان", "چابهار", "ایرانشهر", "زابل", "سراوان"],
  },
  {
    name: "گلستان",
    cities: ["گرگان", "گنبدکاووس", "علی‌آباد", "بندرترکمن", "آق‌قلا"],
  },
  {
    name: "اردبیل",
    cities: ["اردبیل", "پارس‌آباد", "مشگین‌شهر", "خلخال"],
  },
  {
    name: "زنجان",
    cities: ["زنجان", "ابهر", "خدابنده", "خرمدره"],
  },
  {
    name: "سمنان",
    cities: ["سمنان", "شاهرود", "دامغان", "گرمسار"],
  },
  {
    name: "چهارمحال و بختیاری",
    cities: ["شهرکرد", "بروجن", "فارسان", "لردگان"],
  },
  {
    name: "کهگیلویه و بویراحمد",
    cities: ["یاسوج", "دوگنبدان", "دهدشت"],
  },
  {
    name: "ایلام",
    cities: ["ایلام", "دهلران", "آبدانان", "ایوان"],
  },
  {
    name: "خراسان شمالی",
    cities: ["بجنورد", "شیروان", "اسفراین", "جاجرم"],
  },
  {
    name: "خراسان جنوبی",
    cities: ["بیرجند", "قائن", "فردوس", "طبس"],
  },
];

export function filterProvinces(query: string): IranProvince[] {
  const q = query.trim();
  if (!q) return IRAN_PROVINCES;
  return IRAN_PROVINCES.filter((p) => p.name.includes(q));
}

export function citiesForProvince(provinceName: string, query = ""): string[] {
  const p = IRAN_PROVINCES.find((x) => x.name === provinceName);
  if (!p) return [];
  const q = query.trim();
  if (!q) return p.cities;
  return p.cities.filter((c) => c.includes(q));
}
